import FadeInSection from "../../ui/fade-in-section";
import UseCaseBadge from "./use-case-badge";
import IndustryTable from "./industry-table";
import DemoTryButton from "./demo-try-button";

function BulletList({ items, accent = false }) {
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li key={item} className="flex gap-3 text-sm sm:text-[15px] leading-relaxed">
          <span
            className={`mt-2 h-1.5 w-1.5 shrink-0 rounded-full ${
              accent ? "bg-teal" : "bg-slate-300"
            }`}
            aria-hidden
          />
          <span className={accent ? "text-navy font-medium" : "text-slate-600"}>
            {item}
          </span>
        </li>
      ))}
    </ul>
  );
}

export default function UseCaseCard({ useCase, index }) {
  const tableDelay = 0.4 + 0.15;

  return (
    <article className="w-full">
      <FadeInSection y={24} duration={0.4} delay={index * 0.1}>
        <div className="use-case-card bg-white border-l-4 border-teal shadow-sm shadow-slate-200/40 min-w-0 overflow-hidden">
          <div className="p-5 sm:p-8 lg:p-10">
            <div className="flex flex-col gap-5 sm:gap-5 lg:flex-row lg:items-start lg:justify-between mb-6 sm:mb-10">
              <div className="min-w-0 flex-1 order-1">
                <h2 className="text-[1.375rem] sm:text-[1.75rem] font-bold text-navy leading-tight tracking-tight break-words">
                  {useCase.name}
                </h2>
                <div className="flex flex-wrap gap-1.5 sm:gap-2 mt-3 sm:mt-4">
                  {useCase.badges.map((badge) => (
                    <UseCaseBadge
                      key={badge.label}
                      label={badge.label}
                      variant={badge.variant}
                    />
                  ))}
                </div>
              </div>

              <div className="order-2 w-full lg:w-auto shrink-0">
                <DemoTryButton
                  label={useCase.cta.label}
                  demoUrl={useCase.cta.href}
                  demoName={useCase.name}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-14">
              <div>
                <h3 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400 mb-4">
                  What It Does
                </h3>
                <BulletList items={useCase.whatItDoes} />
              </div>

              <div>
                <h3 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-teal mb-4">
                  Business Benefit
                </h3>
                <BulletList items={useCase.businessBenefit} accent />
              </div>
            </div>
          </div>
        </div>
      </FadeInSection>

      <IndustryTable industries={useCase.industries} delay={tableDelay + index * 0.1} />
    </article>
  );
}
